import { graphql } from '@teachino/shared-infrastructure';

export const moveItemsMutation = graphql(`
  mutation MoveItems($multiTopicItemMoveInput: MultiTopicItemMoveInput!) {
    moveItems(multiTopicItemMoveInput: $multiTopicItemMoveInput) {
      done
    }
  }
`);
